(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('countdown-to-midnight')) {
    class CountdownToMidnight extends HTMLElement {
      connectedCallback() {
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const now = new Date();
        const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
        let diff = Math.max(0, endOfDay.getTime() - now.getTime());

        const hours = Math.floor(diff / 3600000);
        diff -= hours * 3600000;
        const minutes = Math.floor(diff / 60000);
        diff -= minutes * 60000;
        const seconds = Math.floor(diff / 1000);

        const pad = (n) => String(n).padStart(2, '0');
        this.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }
    }

    customElements.define('countdown-to-midnight', CountdownToMidnight);
  }
  } catch(e) { console.error(e); }
})();

})();
